window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Library ================*/
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (typeof define === 'function' && define.amd) {
		define(factory);
		registeredInModuleLoader = true;
	}
	if (typeof exports === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '$';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
var lazyLoadimages = (function($) {

  //variables

  var init = function() {

    var lazyLoadImages = new LazyLoad({
      elements_selector: ".lazy",
    });
  
    var lazyLoadWoodWrapper = new LazyLoad({
      elements_selector: ".wrapper-wood",
    });
  
    var lazyLoadMobileNav = new LazyLoad({
      elements_selector: ".mobile-submenu-parent",
    });

  } // end init

  return {
    init:   init,
  }

}(jQuery));
    
$(document).ready(function() {
  lazyLoadimages.init()
})
var NAV = (function($) {

  //variables
  var navbar = document.querySelector('#main-menu');

  var triggerContainer = document.querySelector('.super-dropdown');

  var triggerLink = triggerContainer.querySelector('.mega-trigger');
  var toggleButton = triggerContainer.querySelector('.toggle-button');
  var closeButton = document.querySelector('.mega-menu .close-button');
  var lastMenuItem = document.querySelector("#tab-trigger");
  var mouseOutHideDelay = 0;  // time (in ms) before menu is closed after mouse leaves
  var mouseOutTimer; // timer used to delay hiding of menu after mouse leaves

  var menuVisible = false; // current visibility state of menu
  var hamburger = document.querySelector('.hamburger');
  var mainMenu = document.querySelector('#main-menu');

  var init = function() {

    // Show Mobile Menu
    hamburger.addEventListener('click', function(e) {
      this.classList.toggle( "is-active" );
      mainMenu.classList.toggle( "is-active" );
      
      if(document.querySelector('.hamburger').classList.contains('is-active')) {
        this.setAttribute('aria-expanded', true);
      } else {
        this.setAttribute('aria-expanded', false);
      }

    });

    // Show the menu on mouse hover of the trigger
    triggerContainer.addEventListener('mouseover', function(e) {
      showMenu();
      clearTimeout(mouseOutTimer);
    });
    
    // Removes active state when you hover off. This also handles a delay set with mouseOutHideDelay for people who use a tracking device. 
    triggerContainer.addEventListener('mouseout', function(e) {
      mouseOutTimer = setTimeout(function() {
        hideMenu();
        
      }, mouseOutHideDelay);
    });
            
    // Toggle the menu when the trigger is activated
    toggleButton.addEventListener('click', toggleMenu);
    
    // Close the menu when the close button is clicked
    closeButton.addEventListener('click', hideMenu);

    // Close the menu AND return focus to the trigger when the close button is activted by keyboard
    closeButton.addEventListener('keydown', function(e) {
      if(e.key == 'Enter' || e.key == ' ') {
        e.preventDefault();
        hideMenu();
        toggleButton.focus();
      }
    });
    
    // Close the menu when the user activates something outside the navbar.
    document.body.addEventListener('click', handleBodyClick);


    /**
      Menu visibility
    **/
    function showMenu() {
      triggerLink.setAttribute('aria-expanded', true);
      toggleButton.setAttribute('aria-expanded', true);
      menuVisible = true;
    };

    function hideMenu() {
      triggerLink.setAttribute('aria-expanded', false);
      toggleButton.setAttribute('aria-expanded', false);
      menuVisible = false;
    };

    function hideMobileMenu() {
      hamburger.classList.remove( "is-active" );
      mainMenu.classList.remove( "is-active" );
    }

    function toggleMenu() {
      if(menuVisible) {
        hideMenu();
      } else {
        showMenu();
      }
    };

    /**
      Search visibility
    **/

    var toggleSearchButton = document.querySelector('.search-toggle');
    var closeSearch = document.querySelector('.search-close');
    var searchField = document.querySelector('.nav-search');
    var searchVisible = false;

    function showSearch() {
      searchField.setAttribute('aria-expanded', true);
      searchVisible = true;
      searchField.classList.add( "is-active" );
    };

    function hideSearch() {
      searchField.setAttribute('aria-expanded', false);
      searchVisible = false;
      searchField.classList.remove( "is-active" );
    };

    function toggleSearch() {
      if(searchVisible) {
        hideSearch();
      } else {
        showSearch();
        document.querySelector('.search-input').focus();
      }
    };

    //toggle search
    toggleSearchButton.addEventListener('click', toggleSearch);
    closeSearch.addEventListener('click', hideSearch);


    /**
      Event handlers
    */
    function handleBodyClick(e) {
      // Hide the menu if the user clicks anywhere other than on the navbar or one of it's child menus

      if(!navbar.contains(e.target)) {
        hideMenu();
        hideMobileMenu();
      }
    };
    
    navbar.addEventListener('keydown', function(e) {
      // hide menu when tabbed out of or escape key'd
      
      if((e.key === 'Tab' && e.target === lastMenuItem) || e.key === 'Escape') {
        hideMenu();
        hideMobileMenu();
      }
    });

    $( document ).on( 'keydown', function ( e ) {
      if ( e.keyCode === 27 ) { // ESC
        hideSearch();
      }
    });

  } // end init

  return {
    init:   init,
  }

}(jQuery));
    
$(document).ready(function() {
  NAV.init()
})
var Sliders = (function($) {

  var init = function() {
    
    // create default carousel options
    var flkOptions = {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      on: {
        dragStart: function() {
          document.ontouchmove = function (e) {
              e.preventDefault();
          }
        },
        dragEnd: function() {
          document.ontouchmove = function () {
            return true;
          }
        }  
      },
      wrapAround: false,
      lazyLoad: true
    }
    
    // init carousel
    var $carousel1 = $('.hero-slider').flickity(flkOptions);
    var $carousel2 = $('.onaquest-slider').flickity(flkOptions);
    var $carousel3 = $('.lander-slider').flickity(flkOptions);
    
    // Global Button/Dot triggers
    var $btnOne = $('.hero-slider-wrapper');
    buttonClick($carousel1, $btnOne);

    var $btnTwo = $('.home-onaquest');
    buttonClick($carousel2, $btnTwo);

    var $btnThree = $('.lander-slider-wrapper');
    buttonClick($carousel3, $btnThree);
    
    // Button Click Triggers
    function buttonClick(slider, btn) {
      btn.find( ".carousel-nav__button" ).on('click', function(e) { 
        e.preventDefault();
        updateNav(btn, this);
        var active = btn.find('.carousel-nav .carousel-nav__button--is-active').index();
        slider.flickity( 'select', active);
      })
    }
    
    // Update the slider dot states
    function updateNav(btn, active) {

      btn.find( ".carousel-nav__button" ).removeClass('carousel-nav__button--is-active');
      btn.find( ".carousel-nav__button" ).removeAttr("aria-current"); 
      $(active).addClass('carousel-nav__button--is-active');
      $(active).attr('aria-current', 'true')
    }
    
    // Update the slider on change
    function flkChange(btn, carousel) {
      var index = $(carousel).data('flickity').selectedIndex;
      var active =  btn.find('.carousel-nav .carousel-nav__button').eq(index);
      updateNav(btn, active);
      $(".flickity-enabled").removeAttr("tabindex"); 
    }

    // On change triggers

    $carousel1.on('select.flickity', function() { 
      flkChange($btnOne, this); 
    });

    $carousel2.on('select.flickity', function() { 
      flkChange($btnTwo, this); 
    });

    $carousel3.on('select.flickity', function() { 
      flkChange($btnThree, this); 
    });

    $(".flickity-enabled").removeAttr("tabindex"); 

  } // end init

  return {
    init: init,
  }

}(jQuery));
    
$(document).ready(function() {
  Sliders.init()
})

var loadModals = (function($) {

  //variables

  var init = function() {

    //Global Modals
    $('[data-action="open-new-address-mod al"]').fancybox({
      baseClass: 'fancybox__address-new',
      btnTpl: {
        smallBtn: '<button aria-label="Close" type="button" data-fancybox-close="" class="fancybox-button fancybox-close-small fancybox-close-small--inside" title="Close"><span class="visually-hidden">Close Modal</span><svg aria-hidden="true" id="icon-close-thin" viewBox="0 0 32 32"><path class="path1" d="M18.25 16l13.159 13.27c0.591 0.59 0.591 1.547 0 2.138s-1.547 0.591-2.138 0l-13.27-13.373-13.27 13.373c-0.591 0.591-1.547 0.591-2.138 0s-0.591-1.548 0-2.138l13.159-13.27-13.16-13.27c-0.591-0.591-0.591-1.547 0-2.138s1.548-0.591 2.138 0l13.27 13.372 13.27-13.372c0.591-0.591 1.547-0.591 2.139 0 0.591 0.591 0.591 1.547 0 2.138l-13.159 13.27z"></path></svg></button>'
      },
      afterClose: function() {
        $('#address_form_new').trigger("reset");
      },
    });
  
    $('.button--close-modal').on('click', function(e) {
      e.preventDefault();
      $("button.fancybox-close-small").trigger("click");
    })
  
    $('[data-action="open-edit-address-modal"]').fancybox({
      btnTpl: {
        smallBtn: '<button aria-label="Close" type="button" data-fancybox-close="" class="fancybox-button fancybox-close-small fancybox-close-small--inside" title="Close"><span class="visually-hidden">Close Modal</span><svg aria-hidden="true" id="icon-close-thin" viewBox="0 0 32 32"><path class="path1" d="M18.25 16l13.159 13.27c0.591 0.59 0.591 1.547 0 2.138s-1.547 0.591-2.138 0l-13.27-13.373-13.27 13.373c-0.591 0.591-1.547 0.591-2.138 0s-0.591-1.548 0-2.138l13.159-13.27-13.16-13.27c-0.591-0.591-0.591-1.547 0-2.138s1.548-0.591 2.138 0l13.27 13.372 13.27-13.372c0.591-0.591 1.547-0.591 2.139 0 0.591 0.591 0.591 1.547 0 2.138l-13.159 13.27z"></path></svg></button>'
      },
    });
    
    //QUICK SHOP
    var quickShopModal = $('.quick-shop');
    var quickShopModalContent = $('.quick-shop__content');

    $('[data-src="#modal__quick-shop"]').fancybox({
      baseClass: 'fancybox__quick-shop',
      btnTpl: {
        smallBtn: '<button aria-label="Close" type="button" data-fancybox-close="" class="fancybox-button fancybox-close-small fancybox-close-small--inside" title="Close"><span class="visually-hidden">Close Modal</span><svg aria-hidden="true"  id="icon-close-thin" viewBox="0 0 32 32"><path class="path1" d="M18.25 16l13.159 13.27c0.591 0.59 0.591 1.547 0 2.138s-1.547 0.591-2.138 0l-13.27-13.373-13.27 13.373c-0.591 0.591-1.547 0.591-2.138 0s-0.591-1.548 0-2.138l13.159-13.27-13.16-13.27c-0.591-0.591-0.591-1.547 0-2.138s1.548-0.591 2.138 0l13.27 13.372 13.27-13.372c0.591-0.591 1.547-0.591 2.139 0 0.591 0.591 0.591 1.547 0 2.138l-13.159 13.27z"></path></svg></button>'
      },
      afterLoad: function(instance, slide) {
        var cartButton = slide.opts.$orig;
        var productUrl = $(cartButton).attr('data-quick-shop-url');
        $.ajax(productUrl).then(function(result) {
          quickShopModalContent.html(result);
        });
      },
      afterClose: function() {
        quickShopModalContent.html('<div class="quick-shop__spinner spinner-container spinner-container--large"><div class="spinner spinner--circle"></div></div>');
      },
    });

    //ADD CLASS TO NEW LABELON PRODUCT LOOP PAGES - Unsure
    $(window).bind("load", function () {
      $('.mini-cart__item .product-meta__title a:contains("10.00%")').addClass("removePointer");
    });

    /* 
     * VIDEO MODALS
     */
    $('a[data-fancybox="video"]').fancybox({
      afterLoad: function() {
        $('.fancybox-container').attr("aria-label", "video");
      },
      beforeClose: function() {
        $('.fancybox-container').attr("aria-label", "");
      }
    });
  } // end init

  return {
    init: init,
  }

}(jQuery));
    
$(document).ready(function() {
  loadModals.init()
})
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    imageWrapper: '[data-image-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    numInputs: 'input[type="number"]',
    productCard: '.product-card',
    relatedProducts: '.related-products'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {};
    this.namespace = '.product';

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    this.settings.imageSize = slate.Image.imageSize($(selectors.productFeaturedImage, this.$container).attr('src'));

    slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

    this.initVariants();
    this.initImagesSwitch();
    this.productImageZoom();
    this.initRelatedProducts();
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Handles change events from the variant inputs
     */
    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
      this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    },

    initImagesSwitch: function() {
      if (!$(selectors.productThumbs, this.$container).length) {
        return;
      }

      var self = this;

      $(selectors.productThumbs, this.$container).on('click', function(evt) {
        evt.preventDefault();

        var $el = $(this);
        var imageSrc = $el.attr('href');

        self.switchImage(imageSrc);
      });
    },

    productImageZoom: function() {
      if (!$(selectors.imageWrapper, this.$container).length) {
        return;
      }

      // Destroy zoom (in case it was already set), then set it up again
      $(selectors.imageWrapper, this.$container).trigger('zoom.destroy');

      $(selectors.imageWrapper, this.$container).zoom({
        url: $(selectors.productFeaturedImage, this.$container).data('zoom')
      });
    },

    switchImage: function(imageSrc) {
      $(selectors.productFeaturedImage, this.$container)
        .attr('src', imageSrc)
        .data('zoom', imageSrc);

      this.productImageZoom();
    },

    initRelatedProducts: function() {
      var $relatedProducts = this.$container.siblings(selectors.relatedProducts);

      if (!$relatedProducts.length) {
        return;
      }

      $relatedProducts.on('click.productCard', selectors.productCard, theme.ProductCard.onClick);
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html('Unavailable');
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html('Add to Cart');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html('Sold Out');
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      $(selectors.productFeaturedImage, this.$container).attr('src', sizedImgUrl);

      this.switchImage(sizedImgUrl);
      this.productImageZoom();
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
      $(selectors.productFeaturedImage).off('.productCard');
    }
  });

  return Product;
})();
$(document).ready(function() {

  // Global Ad Banner
  $bannerWrap = $("#shopify-section-ad-banner"); 

  if(Cookies.get('ad-banner')) {
    $("#shopify-section-ad-banner").addClass('no-banner');
  } else {
    $bannerWrap.removeClass('no-banner');
    $bannerWrap.addClass('banner-visible');
  }

  function closeBanner() {
    Cookies.set('ad-banner', true, { expires: 1 });
    $bannerWrap.addClass('banner-hidden');
    $bannerWrap.removeClass('banner-visible');
  }

  $('.ad-banner__btn').click(closeBanner);

  //close banner on escape
  if ($bannerWrap.length > 0) {
    $(document).on('keydown', function(event) {
      if (event.keyCode === 27) {
        closeBanner();
      }
    });
  }


  var variants = [
    // PROTEIN POWDER - PEANUT BUTTER
    {
      collection: "protein-powders",
      single: {
        href: "/protein-powder-peanut-butter",
        text: "1.6lb",
      },
      box: {
        href: "/protein-powder-peanut-butter-3lb",
        text: "3lb",
      },
    },
    // PROTEIN POWDER - VANILLA MILKSHAKE
    {
      collection: "protein-powders",
      box: {
        href: "/protein-powder-vanilla-milkshake-3lb",
        text: "3lb",
      },
      single: {
        href: "/protein-powder-vanila-milkshake",
        text: "1.6lb",
      },
    },
    // PROTEIN POWDER - CHOCOLATE MILKSHAKE
    {
      collection: "protein-powders",
      single: {
        href: "/protein-powder-chocolate-milkshake-1-6lb",
        text: "1.6lb",
      },
      box: {
        href: "/protein-powder-chocolate-milkshake-3lb",
        text: "3lb",
      },
    },
    // PROTEIN BAR - Birthday Cake
    {
      collection: "protein-bars",
      single: {
        href: "/birthday-cake-single",
        text: "Single",
      },
      box: {
        href: "/birthday-cake",
        text: "Box of 12",
      },
    },
	// PROTEIN BAR - CCC
    {
      collection: "protein-bars",
      single: {
        href: "/caramel-chocolate-chunk-1",
        text: "Single",
      },
      box: {
        href: "/caramel-chocolate-chunk",
        text: "Box of 12",
      },
    },
	// PROTEIN BAR - CB
    {
      collection: "protein-bars",
      single: {
        href: "/chocolate-brownie-single",
        text: "Single",
      },
      box: {
        href: "/chocolate-brownie",
        text: "Box of 12",
      },
    },
	// PROTEIN BAR - CCCD
    {
      collection: "protein-bars",
      single: {
        href: "/chocolate-chip-cookie-dough-single",
        text: "Single",
      },
      box: {
        href: "/chocolate-chip-cookie-dough",
        text: "Box of 12",
      },
    },
	// PROTEIN BAR - CSD
    {
      collection: "protein-bars",
      single: {
        href: "/chocolate-sprinkled-doughnut-single",
        text: "Single",
      },
      box: {
        href: "/chocolate-sprinkle-donut",
        text: "Box of 12",
      },
    },
	// PROTEIN BAR - COOKIES AND CREAM
    {
      collection: "protein-bars",
      single: {
        href: "/cookies-cream-single",
        text: "Single",
      },
      box: {
        href: "/cookies-cream",
        text: "Box of 12",
      },
    },
	// PROTEIN BAR - DOUBLE CHOCOLATE CHUNK
    {
      collection: "protein-bars",
      single: {
        href: "/double-chocolate-chunk-single",
        text: "Single",
      },
      box: {
        href: "/double-chocolate-chunk",
        text: "Box of 12",
      },
    },
	// PROTEIN BAR - mint DOUBLE CHOCOLATE CHUNK
    {
      collection: "protein-bars",
      single: {
        href: "/mint-chocolate-chunk-single",
        text: "Single",
      },
      box: {
        href: "/mint-chocolate-chunk",
        text: "Box of 12",
      },
    },
	// PROTEIN BAR - smores
    {
      collection: "protein-bars",
      single: {
        href: "/smores-single",
        text: "Single",
      },
      box: {
        href: "/smores",
        text: "Box of 12",
      },
    },
	// PROTEIN BAR - smores
    {
      collection: "protein-bars",
      single: {
        href: "/white-chocolate-raspberry-single",
        text: "Single",
      },
      box: {
        href: "/white-chocolate-raspberry",
        text: "Box of 12",
      },
    },     
  ];

  if ($('body').hasClass('template-product')) {

    $('#rc_container input[type=radio]').addClass('i_am_radio');

    $('#rc_container input[type=radio]').focus(function() {
      $('#rc_container fieldset').addClass('in-focus');
    });

    $('#rc_container input[type=radio]').focusout(function() {
      $('#rc_container fieldset').removeClass('in-focus');
    });

    $('.rc_select__frequency').focus(function() {
      $('#rc_container fieldset').addClass('in-focus');
    });

    $('.rc_select__frequency').focusout(function() {
      $('#rc_container fieldset').removeClass('in-focus');
    });

    // $('#rc_container input[type=radio]').off('focus', function() {
    //   $('#rc_container fieldset').removeClass('in-focus');
    // });

    // $(document).on('keydown', function(event) {
    //   console.log(event.target);
    // });

    //Hide if not Variation!
    $('.product-variation-link-right-top').hide();

    var singleLink = $('.product-variation-link-right-top li a#product-variation-single');
    var boxLink = $('.product-variation-link-right-top li a#product-variation-box');
    var bulkLink = $('.product-variation-link-right-top li a#product-variation-bulk');

    for (const variant of variants) {
      var isSingle = document.URL.indexOf(variant.single.href) >= 0;
      var isBox = document.URL.indexOf(variant.box.href) >= 0;
      var isBulk = variant.bulk ? document.URL.indexOf(variant.bulk.href) >= 0 : false;

      if ( isSingle || isBox || isBulk ) {
        // Show variant select buttons
        $('.product-variation-link-right-top').show();

        // Single set up
        $(singleLink).attr('href','/collections/' + variant.collection + '/products' + variant.single.href);
        $(singleLink).text(variant.single.text);

        // Box set up
        $(boxLink).attr('href','/collections/' + variant.collection + '/products' + variant.box.href);
        $(boxLink).text(variant.box.text);

        if (variant.bulk) {
          $(bulkLink).attr('href','/collections/' + variant.collection + '/products' + variant.bulk.href);
          $(bulkLink).text(variant.bulk.text);
        }

        // Set active variant link
        if (isSingle) {
          var activeLink = $(singleLink);
        } else if (isBox) {
          var activeLink = $(boxLink);
        } else {
          var activeLink = $(bulkLink);
        }

        $(activeLink).addClass('active-variation');
        $(activeLink).attr('aria-current', 'page');

        if (variant.glutenFree === false) {
          $('#gluten-free-icon').remove();
        }

        // Stop checking through variants
        break;
      }
    }
  }
});
var quickJump = (function($) {

  var init = function() {
    var lastQuickFlavor = $('.product-quick-jump__link_last');

    function closeQuickJump() {
      $('.product-quick-jump__dropdown-wrapper').removeClass('open');
      $('.product-quick-jump__icon').removeClass('product-quick-jump__icon--open');
    }

    function toggleQuickJump() {
      $('.product-quick-jump__dropdown-wrapper').toggleClass('open');
      $('.product-quick-jump__icon').toggleClass('product-quick-jump__icon--open');
    }

    function triggerKeydownHandler(e) {
      var isTarget = $(e.target).hasClass('product-quick-jump__link_last');

      if((e.key === 'Tab' && !e.shiftKey && isTarget) || e.key == 'Escape') {
        closeQuickJump();
        
        // Move focus back to the menu toggle button if Escape was pressed
        if(e.key == 'Escape') {
          $('.product-quick-jump__button').focus();
        }
      }
    }
    
    // Product Quick Jump
    $('.product-quick-jump__button').click(function() {
      toggleQuickJump();

      if ($('.product-quick-jump__dropdown-wrapper').hasClass('open')) {
        $(this).attr('aria-expanded', true);
        $('body').on('keydown', triggerKeydownHandler);
      } else {
        $(this).attr('aria-expanded', false);
        $('.product-quick-jump').off('keydown', triggerKeydownHandler);
      }
    })

    // Collection Quick Jump
    $('.collection-quick-jump__button').click(function() {
      $('.collection-quick-jump__dropdown-wrapper').toggleClass('open');
      $('.collection-quick-jump__icon').toggleClass('collection-quick-jump__icon--open');
    })

  } // end init

  return {
    init:   init,
  }

}(jQuery));
    
$(document).ready(function() {
  quickJump.init()
})
var Accordions = (function($) {

  //variables

  var init = function() {

    function expandAccordion(id)  {
      $(".accordion").removeClass("active");
      $(".accordion ~ .panel").css("display", "none");
      $("#" + id).addClass("active");
      $("#" + id).next(".panel").slideDown();
    };
  
    $(".accordion").click(function () {
      if ($(this).hasClass("active")) {
  
        $(this).next(".panel").css("display", "none");
        $(this).removeClass("active");
        $(this).attr('aria-expanded', false);

      } else {
  
        $(".accordion").removeClass("active");
        $(".accordion").attr('aria-expanded', false);
        $(".accordion ~ .panel").css("display", "none");
        
        $(this).addClass("active");
        $(this).next(".panel").slideDown();
        $(this).attr('aria-expanded', true);

      }   
    });
  


  } // end init

  return {
    init:   init,
  }

}(jQuery));
    
$(document).ready(function() {
  Accordions.init()
})
  
var ajaxCart = (function($) {

  var init = function() {

    function cartKeyListener(e, first, last, active = null) {
      let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
      let isEscPressed = e.key === 'Escape' || e.keyCode === 27;
      
      if (!isTabPressed && !isEscPressed) {
        return;
      }

      if (isEscPressed) {
        closeMiniCart(active);
      }
      
      // if shift key pressed for shift + tab combination
      if (e.shiftKey) { 
        if (document.activeElement === first) {
          last.focus();
          e.preventDefault();
        }
      } else { // if tab key is pressed
        if (document.activeElement === last) { 
          first.focus();
          e.preventDefault();
        }
      }
    }

    function trapCartFocus(activeFocus = null) {
      const  focusableElements = 'button, a, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

      // First element to be focused inside cart
      const firstFocusableElement = $('.mini-cart').find(focusableElements)[0];

      setTimeout(function() { $(firstFocusableElement).focus(); }, 150);
      
      const focusableContent = $('.mini-cart').find(focusableElements);

      // Last element to be focused inside cart
      const lastFocusableElement = focusableContent[focusableContent.length - 1];

      document.addEventListener('keydown', function(e) { cartKeyListener(e, firstFocusableElement, lastFocusableElement, activeFocus); });
    }

    function openMiniCart(activeFocus = null) {
      $('body').addClass('cart-open no-scroll');
      $('.mini-cart').addClass('mini-cart_open');

      $('.page__overlay').on('click', function() {
        closeMiniCart(activeFocus);
      });
      $('button[data-action="close-mini-cart"]').on('click', function() {
        closeMiniCart(activeFocus);
      });

      trapCartFocus(activeFocus);
    }

    function closeMiniCart(activeFocus = null) {
      $('body').removeClass('cart-open no-scroll');
      $('.mini-cart').removeClass('mini-cart_open');

      if (activeFocus === null) {
        $('button[data-action="open-mini-cart"]').focus();
      } else {
        $(activeFocus).focus();
      }
      document.removeEventListener('keydown', cartKeyListener);
      $('.page__overlay').off('click', closeMiniCart);
      $('button[data-action="close-mini-cart"]').off('click', closeMiniCart);
    }

    function updateQuantity(product, method, amount = 1) {
      var item = $('.mini-cart__item[data-product-id="' + product + '"]');
      var lineItem = item.attr('data-index');
      var itemQuantity = parseInt(item.attr('data-quantity'));

      var operation = method === 'increase' ? 'plus' : 'minus';

      if (method === 'increase') {
        itemQuantity = itemQuantity + amount;
      } else if (method === 'decrease') {
        itemQuantity = itemQuantity - amount;
      }

      $('.mini-cart').addClass('mini-cart_reloading');

      $.post({
        url: '/cart/change.js',
        dataType: 'json',
        data: {
          quantity: itemQuantity,
          line: parseInt(lineItem)
        }
      }).then(function() {
        $.ajax('/cart?view=mini-cart-content').then(function(cartContent) {
          rerenderMiniCart(cartContent, {id: product, operation});
        });
      });

      return false;
    }

    function rerenderMiniCart(content, product = null) {
      var newContent = $(content);

      $('.mini-cart__content').html(newContent);

      var itemCount = $('.mini-cart__container').attr('data-item-count');

      $('.mini-cart__count').text(itemCount);
      $('.cart-counter').text(itemCount);

      if (itemCount == 0) {
        $('.mini-cart__count').addClass('mini-cart__count_hidden');
        $('.cart-counter').addClass('cart-counter_hidden');
      } else if (itemCount > 0 && $('.mini-cart__count').hasClass('mini-cart__count_hidden')) {
        $('.mini-cart__count').removeClass('mini-cart__count_hidden');
        $('.cart-counter').removeClass('cart-counter_hidden');
      }

      $('.mini-cart button[data-action="remove-product"]').on('click', removeProduct);
      $('.mini-cart button[data-action="update-quantity"]').on('click', function() {
        var productId = $(this).closest('.mini-cart__item').attr('data-product-id');

        if ($(this).hasClass('minus-button')) {
          updateQuantity(productId, 'decrease');
        } else {
          updateQuantity(productId, 'increase');
        }
      });

      $('.mini-cart').removeClass('mini-cart_reloading');

      if ($('body').hasClass('cart-open')) {
        if (product !== null) {
          var activeButton = $('.mini-cart__item[data-product-id="' + product.id + '"] .' + product.operation + '-button');
          $(activeButton).focus();
        } else {
          const  focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

          const firstFocusableElement = $('.mini-cart__content').find(focusableElements)[0];
          $(firstFocusableElement).focus();
        }
      }
    }

    function removeProduct(event) {
      var item = $(event.currentTarget).closest('.mini-cart__item');
      var lineItem = item.attr('data-index');

      $('.mini-cart').addClass('mini-cart_reloading');

      $.post({
        url: '/cart/change.js',
        dataType: 'json',
        data: {
          quantity: 0,
          line: parseInt(lineItem)
        }
      }).then(function() {
        $.ajax('/cart?view=mini-cart-content').then(function(cartContent) {
          item.slideUp(150, function() {
            rerenderMiniCart(cartContent);
          });
        });
      });

      return false;
    }

    function addProduct(e) {
      e.preventDefault();

      var addToCartButton = $(this);

      if ($(this).hasClass('product__add-to-cart')) {
        var productForm = $(this).parent('.product-form');
        var addedData = productForm.serialize();
      } else {
        var productId = $(this).attr('data-product');
        var addedData = 'purchase_type=onetime&id='+ productId +'&quantity=1';
      }

      addToCartButton.html('Adding...');
      addToCartButton.attr('disabled', 'disabled');

      addToCartButton.html('Add to Cart');

      $.post({
        url: '/cart/add.js',
        data: addedData,
        dataType: 'json'
      }).then(function(result) {
        // We throw an event so that our mini-cart can do additional processing like re-rendering the mini-cart
        $.ajax('/cart?view=mini-cart-content').then(function(cartContent) {
          rerenderMiniCart(cartContent);
          openMiniCart(addToCartButton);

          addToCartButton.removeAttr('disabled');
  
          addToCartButton.html('Added to Cart');
    
          // We restore original button message after 2 seconds
          setTimeout(function() {
            addToCartButton.html('Add to Cart');
          }, 1000);
        });
      }).catch(function(error) {
        addToCartButton.html(error.responseJSON.description);
  
        // We restore original button message after 2 seconds
        setTimeout(function() {
          addToCartButton.html('Add to Cart');
          addToCartButton.removeAttr('disabled');
        }, 2000);
      });
    }

    var ua = window.navigator.userAgent;
    var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    var webkit = !!ua.match(/WebKit/i);
    var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
  
    if (iOSSafari) {
      $('body').addClass('ios');
    }

    $.ajax('/cart?view=mini-cart-content').then(function(cartContent) {
      rerenderMiniCart(cartContent);
    });

    $('button[data-action="open-mini-cart"]').not('[aria-disabled="true"]').on('click', function() {
      openMiniCart();
    });

    $('button[data-add-to-cart]').on('click', addProduct);

  } // end init

  return {
    init:   init,
  }

}(jQuery));
    
$(document).ready(function() {
  ajaxCart.init()
})
var cartTools = (function($) {

  var init = function() {

    /**
     * -------------------------
     * COLD SHIP CHECK
     * -------------------------
     */

    function checkColdShip() {
      $.getJSON('/cart.js', function(cart) {
        var isColdShip = false;
        var shippingNote;
        var coldShipItems = [133305204742,	  // Birthday cake caddy
                             15873071054922,	// Birthday cake single
                             44691863238,		  // Hero Blueberry Cobbler
                             44688056390,		  // Hero Chocolate Caramel Pecan
                             44694591814,		  // Hero Vanilla Caramel
                             16355923591242,	// Doughnut caddy
                             28553339732042,	// Doughnut single
                             8687665184878,	  // Maple caddy
                             28553341927498];	// Maple single

        $.each( cart.items, function( key, value ) {
          if($.inArray(value.id, coldShipItems) >= 0) {
            isColdShip = true;
            return false;
          }
        });

        if(isColdShip)
          shippingNote = 'Cold Ship'
        else
          shippingNote = '';


        $.post({
          url: '/cart/update.js',
          dataType: 'json',
          data: {
            note: shippingNote,
          }
        });
      });
    }

    if ($('body').hasClass('template-cart')) {
      checkColdShip();
    }


    /**
     * -------------------------
     * SHIPPING ESTIMATOR
     * -------------------------
     */

     $('.shipping-estimate').on('click', function(e) {
       e.preventDefault();

      $('.shipping-estimator').addClass('shipping-estimator_visible');

      // If enter is pressed within estimator form, prevent cart form from submitting
      $('.shipping-estimator').on('keydown', function(e) {
        var isEnterPressed = e.key === 'Enter' || e.keyCode === 13;

        if (!isEnterPressed) return;

        e.preventDefault();
        $('.shipping-estimator__submit').click();
      });

      $('.shipping-estimator #address_province').focus();
     });

    var shippingEstimator = $('.shipping-estimator');
    
    var shippingEstimatorSubmit = shippingEstimator.find('.shipping-estimator__submit');
    var shippingEstimatorResults = shippingEstimator.find('.shipping-estimator__results');
    var shippingEstimatorList = shippingEstimatorResults.find('.shipping-estimator__list');
    var cartEstimatedShipping = $('.cart-footer__total_shipping');

    $('.shipping-estimator__submit').on('click', function() {
      shippingEstimatorSubmit.html(window.languages.shippingEstimatorSubmitting);

      $.ajax({
        method: 'GET',
        url: '/cart/shipping_rates.json',
        data: {
          shipping_address: {
            country: shippingEstimator.find('#address_country').val(),
            province: shippingEstimator.find('#address_province').val(),
            zip: shippingEstimator.find('#address_zip').val()
          }
        },
        success: function(results) {
          shippingEstimatorList.empty();

          if (results['shipping_rates'].length === 0) {
            shippingEstimatorResults.find('.shipping-estimator__results-title').html(window.languages.shippingEstimatorNoRates);
          } else {
            shippingEstimatorResults.find('.shipping-estimator__results-title').html(window.languages.shippingEstimatorRates);
          }

          results['shipping_rates'].forEach(function(item) {
            var amount = slate.Currency.formatMoney(item['price'] * 100, window.shop.moneyFormat)

            shippingEstimatorList.append('<li class="shipping-estimator__item">' + item['name'] + ': <span data-money-convertible>' + amount + '</span></li>');
          });

          if (results['shipping_rates'].length > 0) {
            var firstPrice = slate.Currency.formatMoney(results['shipping_rates'][0]['price'] * 100, window.shop.moneyFormat);

            cartEstimatedShipping.removeClass('hidden');

            cartEstimatedShipping.html(window.languages.cartEstimatedShipping + ' ' + firstPrice);
          }

          if ($('#address_province').attr('aria-describedby')) {
            $('#address_province').removeAttr('aria-describedby');
          }
          if ($('#address_zip').attr('aria-describedby')) {
            $('#address_zip').removeAttr('aria-describedby');
          }

          $('.cart-footer .button-checkout').focus();
        },
        error: function(results) {
          shippingEstimatorList.empty();
          shippingEstimatorResults.find('.shipping-estimator__results-title').html(window.languages.shippingEstimatorError);

          var response = results.responseJSON;
          var errors = [];

          for (var key in response) {
            if (response.hasOwnProperty(key)) {
              errors.push({key: key, value: response[key][0]});
            }
          }

          var stateErrors = [];
          var zipErrors = [];
          var errorCount = 0;

          errors.forEach(function(item) {
            errorCount++;

            if (item['key'] === 'province') item['key'] = 'state';
            
            var errorId = item['key'] + '-error-' + errorCount;

            if (item['key'] === 'state') stateErrors.push(errorId);
            else if (item['key'] === 'zip') zipErrors.push(errorId);

            shippingEstimatorList.append('<li class="shipping-estimator__item" id="' + errorId + '">' + item['key'] + ': ' + item['value'] + '</li>');
          });

          if (stateErrors.length > 0) {
            $('#address_province').attr('aria-describedby', stateErrors.join(' '));
          }
          if (zipErrors.length > 0) {
            $('#address_zip').attr('aria-describedby', zipErrors.join(' '));
          }

          if (errors[0]['key'] === 'zip') {
            $('#address_zip').focus();
          } else if (errors[0]['key'] === 'state') {
            $('#address_province').focus();
          }
        },
        complete: function(results) {
          shippingEstimatorSubmit.html(window.languages.shippingEstimatorSubmit);
          shippingEstimatorResults.removeClass('hidden');
        }
      });

      return false;
    });

    // Sangeetha: bug fix. CountryProvinceSelector code below was throwing an null exception
    // when Shopping cart was empty, and thereby preventing other onload javascript from firing.
    if ($(".shipping-estimator").length > 0) {
      new Shopify.CountryProvinceSelector('address_country', 'address_province', {hideElement: 'address_province_container'});
    }
  } // end init

  return {
    init:   init,
  }
  
}(jQuery));
      
$(document).ready(function() {
  cartTools.init()
})

var cart = (function($) {

  var init = function() {

    function rerenderEmptyCart(content) {
      var newContent = $(content);
      var itemCount = newContent.attr('data-item-count');

      $('.mini-cart__count').text(itemCount);
      $('.cart-counter').text(itemCount);

      $('.mini-cart__count').addClass('mini-cart__count_hidden');
      $('.cart-counter').addClass('cart-counter_hidden');
      
      $('.shopify-section__cart .wrap-container').html(newContent);

      // Add button listeners again
      $('.cart-grid').removeClass('cart-grid_reloading');

      $('.cart-link').focus();
    }

    function rerenderCart(content, cart = null, product = null) {
      var newContent = $(content);
      // var itemCount = cart.item_count;

      $('.mini-cart__count').html(cart.item_count);
      $('.cart-counter').html(cart.item_count);

      if (cart.item_count > 0 && $('.mini-cart__count').hasClass('mini-cart__count_hidden')) {
        $('.mini-cart__count').removeClass('mini-cart__count_hidden');
        $('.cart-counter').removeClass('cart-counter_hidden');
      }

      $('.shopify-section__cart .cart-grid__wrap').html(newContent);

      // Update headers and footers
      var cartTotal = slate.Currency.formatMoney(cart.total_price, window.shop.moneyFormat)
      $('.cart-header__meta_count span').html(cart.item_count);
      $('.cart-header__meta_subtotal span').html(cartTotal);
      $('.cart-footer__total .total-wrap').html(cartTotal);

      // Update shipping notice
      var coldShip = false;
      if ($('.cart-grid__wrap').find('.item__cold').length > 0) {
        coldShip = true;
      }

      if (!coldShip && $('.shipping-cold').length > 0) {
        $('.shipping-cold').remove();
      }

      $('.shipping-estimator__results').addClass('hidden');
      
      $('.cart-footer__total_shipping').addClass('hidden');
      $('.cart-footer__total_shipping').empty();

      // Add button listeners again
      $('.cart-grid button[data-action="remove-product"]').on('click', removeProduct);
      $('.cart-grid button[data-action="update-quantity"]').on('click', updateQuantity);

      $('.cart-grid').removeClass('cart-grid_reloading');

      if (product !== null) {
        var activeButton = $('.cart-grid__item[data-variant-id="' + product.id + '"] .' + product.method + '-button');
        $(activeButton).focus();
      } else {
        const  focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

        const firstFocusableElement = $('.cart-grid__list').find(focusableElements)[0];
        $(firstFocusableElement).focus();
      }
    }

    function updateQuantity(event) {
      var self = event.currentTarget;
      var method = $(self).attr('data-method');
      var productId = $(self).closest('.cart-grid__item').attr('data-variant-id');
      var item = $('.cart-grid__item[data-variant-id="' + productId + '"]');
      var lineItem = item.attr('data-index');
      var itemQuantity = parseInt(item.attr('data-quantity'));

      itemQuantity = method === 'plus' ? itemQuantity + 1 : itemQuantity - 1;

      $('.cart-grid').addClass('cart-grid_reloading');

      $.post({
        url: '/cart/change.js',
        dataType: 'json',
        data: {
          quantity: itemQuantity,
          line: parseInt(lineItem)
        }
      }).then(function() {
        $.getJSON("/cart.js", function(cart) { 
          if (cart.item_count == 0) {
            $.ajax('/cart?view=cart-content-empty').then(function(cartContent) {
              rerenderEmptyCart(cartContent);
            });
          } else {
            $.ajax('/cart?view=cart-content').then(function(cartContent) {
              rerenderCart(cartContent, cart, {id: productId, method});
            });
          }
        });
      });

      return false;
    }
 
    function removeProduct(event) {
      var item = $(event.currentTarget).closest('.cart-grid__item');
      var lineItem = item.attr('data-index');

      $('.cart-grid').addClass('cart-grid_reloading');

      $.post({
        url: '/cart/change.js',
        dataType: 'json',
        data: {
          quantity: 0,
          line: parseInt(lineItem)
        }
      }).then(function() {
        $.getJSON("/cart.js", function(cart) { 
          if (cart.item_count == 0) {
            $.ajax('/cart?view=cart-content-empty').then(function(cartContent) {
              item.slideUp(150, function() {
                rerenderEmptyCart(cartContent);
              });
            });
          } else {
            $.ajax('/cart?view=cart-content').then(function(cartContent) {
              item.slideUp(150, function() {
                rerenderCart(cartContent, cart);
              });
            });
          }
        });
      });

      return false;
    }

    $('.cart-grid button[data-action="remove-product"]').on('click', removeProduct);

    $('.cart-grid button[data-action="update-quantity"]').on('click', updateQuantity);

  } // end init

  return {
    init:   init,
  }

}(jQuery));
    
$(document).ready(function() {
  cart.init()
})
var tabsADA = (function($) {

  //variables

  var init = function() {

    var tablist = document.querySelectorAll('[role="tablist"]')[0];
    var tabs;
    var panels;
    var delay = determineDelay();

    generateArrays();

    function generateArrays () {
      tabs = document.querySelectorAll('[role="tab"]');
      panels = document.querySelectorAll('[role="tabpanel"]');
    };
  
    // For easy reference
    var keys = {
      end: 35,
      home: 36,
      left: 37,
      up: 38,
      right: 39,
      down: 40,
      delete: 46
    };
  
    // Add or substract depending on key pressed
    var direction = {
      37: -1,
      38: -1,
      39: 1,
      40: 1
    };
  
    // Bind listeners
    for (i = 0; i < tabs.length; ++i) {
      addListeners(i);
    };
  
    function addListeners (index) {
      tabs[index].addEventListener('click', clickEventListener);
      tabs[index].addEventListener('keydown', keydownEventListener);
      tabs[index].addEventListener('keyup', keyupEventListener);
  
      // Build an array with all tabs (<button>s) in it
      tabs[index].index = index;
    };
  
    // When a tab is clicked, activateTab is fired to activate it
    function clickEventListener (event) {
      var tab = event.target;
      activateTab(tab, false);
    };
  
    // Handle keydown on tabs
    function keydownEventListener (event) {
      var key = event.keyCode;
  
      switch (key) {
        case keys.end:
          event.preventDefault();
          // Activate last tab
          activateTab(tabs[tabs.length - 1]);
          break;
        case keys.home:
          event.preventDefault();
          // Activate first tab
          activateTab(tabs[0]);
          break;
  
        // Up and down are in keydown
        // because we need to prevent page scroll >:)
        case keys.up:
        case keys.down:
          determineOrientation(event);
          break;
      };
    };
  
    // Handle keyup on tabs
    function keyupEventListener (event) {
      var key = event.keyCode;
  
      switch (key) {
        case keys.left:
        case keys.right:
          determineOrientation(event);
          break;
        case keys.delete:
          determineDeletable(event);
          break;
      };
    };
  
    // When a tablists aria-orientation is set to vertical,
    // only up and down arrow should function.
    // In all other cases only left and right arrow function.
    function determineOrientation (event) {
      var key = event.keyCode;
      var vertical = tablist ? tablist.getAttribute('aria-orientation') == 'vertical' : null;
      var proceed = false;
  
      if (vertical) {
        if (key === keys.up || key === keys.down) {
          event.preventDefault();
          proceed = true;
        };
      }
      else {
        if (key === keys.left || key === keys.right) {
          proceed = true;
        };
      };
  
      if (proceed) {
        switchTabOnArrowPress(event);
      };
    };
  
    // Either focus the next, previous, first, or last tab
    // depening on key pressed
    function switchTabOnArrowPress (event) {
      var pressed = event.keyCode;
  
      for (x = 0; x < tabs.length; x++) {
        tabs[x].addEventListener('focus', focusEventHandler);
      };
  
      if (direction[pressed]) {
        var target = event.target;
        if (target.index !== undefined) {
          if (tabs[target.index + direction[pressed]]) {
            tabs[target.index + direction[pressed]].focus();
          }
          else if (pressed === keys.left || pressed === keys.up) {
            focusLastTab();
          }
          else if (pressed === keys.right || pressed == keys.down) {
            focusFirstTab();
          };
        };
      };
    };
  
    // Activates any given tab panel
    function activateTab (tab, setFocus) {
      setFocus = setFocus || true;
      // Deactivate all other tabs
      deactivateTabs();
  
      // Remove tabindex attribute
      tab.removeAttribute('tabindex');
  
      // Set the tab as selected
      tab.setAttribute('aria-selected', 'true');
  
      // Get the value of aria-controls (which is an ID)
      var controls = tab.getAttribute('aria-controls');
  
      // Remove hidden attribute from tab panel to make it visible
      document.getElementById(controls).removeAttribute('hidden');
  
      // Set focus when required
      if (setFocus) {
        tab.focus();
      };
    };
  
    // Deactivate all tabs and tab panels
    function deactivateTabs () {
      for (t = 0; t < tabs.length; t++) {
        tabs[t].setAttribute('tabindex', '-1');
        tabs[t].setAttribute('aria-selected', 'false');
        tabs[t].removeEventListener('focus', focusEventHandler);
      };
  
      for (p = 0; p < panels.length; p++) {
        panels[p].setAttribute('hidden', 'hidden');
      };
    };
  
    // Make a guess
    function focusFirstTab () {
      tabs[0].focus();
    };
  
    // Make a guess
    function focusLastTab () {
      tabs[tabs.length - 1].focus();
    };
  
    // Detect if a tab is deletable
    function determineDeletable (event) {
      target = event.target;
  
      if (target.getAttribute('data-deletable') !== null) {
        // Delete target tab
        deleteTab(event, target);
  
        // Update arrays related to tabs widget
        generateArrays();
  
        // Activate the closest tab to the one that was just deleted
        if (target.index - 1 < 0) {
          activateTab(tabs[0]);
        }
        else {
          activateTab(tabs[target.index - 1]);
        };
      };
    };
  
    // Deletes a tab and its panel
    function deleteTab (event) {
      var target = event.target;
      var panel = document.getElementById(target.getAttribute('aria-controls'));
  
      target.parentElement.removeChild(target);
      panel.parentElement.removeChild(panel);
    };
  
    // Determine whether there should be a delay
    // when user navigates with the arrow keys
    function determineDelay () {
      var hasDelay = tablist ? tablist.hasAttribute('data-delay') : null;
      var delay = 0;
  
      if (hasDelay) {
        var delayValue = tablist ? tablist.getAttribute('data-delay') : null;
        if (delayValue) {
          delay = delayValue;
        }
        else {
          // If no value is specified, default to 300ms
          delay = 300;
        };
      };
  
      return delay;
    };
  
    //
    function focusEventHandler (event) {
      var target = event.target;
  
      setTimeout(checkTabFocus, delay, target);
    };
  
    // Only activate tab on focus if it still has focus after the delay
    function checkTabFocus (target) {
      focused = document.activeElement;
  
      if (target === focused) {
        activateTab(target, false);
      };
    };

  } // end init

  return {
    init:   init,
  }

}(jQuery));
    
$(document).ready(function() {
  tabsADA.init()
})
$(document).ready(function() {

  // MISSION PAGE

   //Desktop Mission Video//  ==============================================================//
   $('.mission-video-container .play-video').click(function(){
     $(this).hide();
     $('.mission-video-container .poloroid-parent').removeClass('pol-rotate-9-right');
     $('.mission-video-container-player').addClass('vid-z-up');
     $('#missionVideo').get(0).play();
   });

   $('.stop-video').click(function(){
     $('.youtube-video')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
     $('.poloroid-parent').addClass('pol-rotate-9-right');
     $('.mission-video-container-player').removeClass('vid-z-up');
   });

   //Mobile Mission Video//  ==============================================================//
   $('.mission-video-container-mobile .play-video-mobile').click(function(){
     $(this).hide();
     $('.mission-video-container-player').addClass('vid-z-up');
     $('#missionVideoMobile').get(0).play();
   });

   $('.stop-video').click(function(){
     $('.youtube-video')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
     $('.poloroid-parent').addClass('pol-rotate-9-right');
     $('.mission-video-container-player').removeClass('vid-z-up');
   });

   //END Mobile Mission Video//  ==============================================================//

   $('.show-desktop .story-button-container button').click(function() {
     $('.story-timeline-container').toggleClass('story-timeline-container--open');
   });

   $('.show-mobile .story-button-container button').click(function() {
     $('.mobile-story-timeline-container').toggleClass('mobile-story-timeline-container--open');
   });
   
 });
var virtualExpo = (function($) {

  //variables

  var init = function() {

    if ($('.page-expolander').length > 0) {
      $('#questheroes').submit(function(event) {
        event.preventDefault();

        var formResponse = {
          firstName: $('#firstName').val(),
          lastName: $('#lastName').val(),
          email: $('#email').val(),
          heroType: $('#heroType option:selected').html(),
          heroId: $('#heroId').val(),
          customerId: $('#customerId').val(),
          customerTags: $('#customerTags').val(),
        };
        
        if ($('#customerId').val() === "") {
          $('.form__error').removeClass('form__error_hidden');
          $('.form__error').html('Please login or create an account.');
        } else {
          $.ajax({
            url: "https://elegantseagullsdev.com/client/quest-blog/wp-json/airtable/v1/questheroes",
            type: "POST",
            data: formResponse,
            success: function (response) {
              $('.form__error').addClass('form__error_hidden');
              $('#questheroes')[0].reset();
              $('.form__thanks').addClass('form__thanks_visible');
              $('html, body').animate({
                scrollTop:  $('.form__thanks').offset().top - 200
              }, 1000);
            },
            error: function (data, exception) {
              $('.form__error').removeClass('form__error_hidden');

              $msg = '';

              if (data === undefined) {
                $msg = 'Unable to submit response';
              } else if (data['responseJSON']['data']['error'] === 'Missing fields.') {
                $msg = 'Please fill out all of the fields';
              } else if (data['responseJSON']['data']['error'] === 'Discount Applied.') {
                $msg = 'The discount has already been applied to your account.';
              } else {
                // $msg = 'Unable to submit response';
                $msg = data['responseJSON']['data']['error'];
              }

              $('.form__error').html($msg);
            },
          });
        }
      });
    }

  } // end init

  return {
    init:   init,
  }

}(jQuery));
    
$(document).ready(function() {
  virtualExpo.init()
})

/*================ Templates ================*/
 /**
   *
   *  Show/hide customer address forms
   *
   */
  var customerAddressForm = (function($) {

    var init = function() {
      
      var $newAddressForm = $('#AddressNewForm');
      var $newAddressFormButton = $('#AddressNewButton');
  
      if (!$newAddressForm.length) {
        return;
      }
  
      // Initialize observers on address selectors, defined in shopify_common.js
      if (Shopify) {
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(
          'AddressCountryNew',
          'AddressProvinceNew',
          {
            hideElement: 'AddressProvinceContainerNew'
          }
        );
      }
  
      // Initialize each edit form's country/province selector
      $('.address-country-option').each(function() {
        var formId = $(this).data('form-id');
        var countrySelector = 'AddressCountry_' + formId;
        var provinceSelector = 'AddressProvince_' + formId;
        var containerSelector = 'AddressProvinceContainer_' + formId;
  
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
          hideElement: containerSelector
        });
      });
  
      // Toggle new/edit address forms
      $('.address-new-toggle').on('click', function() {
        var isExpanded = $newAddressFormButton.attr('aria-expanded') === 'true';
  
        $newAddressForm.toggleClass('hide');
        $newAddressFormButton.attr('aria-expanded', !isExpanded).focus();
      });
  
      $('.address-edit-toggle').on('click', function() {
        var formId = $(this).data('form-id');
        var $editButton = $('#EditFormButton_' + formId);
        var $editAddress = $('#EditAddress_' + formId);
        var isExpanded = $editButton.attr('aria-expanded') === 'true';
  
        $editAddress.toggleClass('hide');
        $editButton.attr('aria-expanded', !isExpanded).focus();
      });
  
      $('.address-delete').on('click', function() {
        var $el = $(this);
        var target = $el.data('target');
        var confirmMessage = $el.data('confirm-message');
  
        // eslint-disable-next-line no-alert
        if (
          confirm(
            confirmMessage || 'Are you sure you wish to delete this address?'
          )
        ) {
          Shopify.postLink(target, {
            parameters: { _method: 'delete' }
          });
        }
      });
  
    } // end init
  
    return {
      init: init,
    }
  
  }(jQuery));
      
  $(document).ready(function() {
    customerAddressForm.init()
  })
  
/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   * -------------------------
   * SWITCH TO RECOVER FORM
   * -------------------------
   */
  $('document').ready(function(){  
    
    var switchToRecoverForm = function() {
      $('.login-form, .recover-form').toggle();
      $('.page__title').text(window.languages.passwordRecoverTitle);
    };

    $('.login-form__forgot').on('click', function() {
      console.log('working');
      switchToRecoverForm();
      return false;
    });

    // We also switch if we directly have the hash "recover"
    if (window.location.hash === '#recover' || window.recoverPassword === true) {
      switchToRecoverForm();
    }

    $('.password__admin-link [data-action="storefront-password"]').on('click', function() {
      $('.password__storefront-form').slideDown();
    });

  });
  
  
})();


// ideaworld scripts for 2021 will need to be included, excluded now for javascript savings //

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
  
    var container = document.querySelector('.floating-label');
  var input = document.querySelector('.floating-label input');
  
  // Make the label float when the field is focused
  input.addEventListener('focus', function(e) {
    container.classList.add('has-focus');
    container.classList.add('is-floating');
  });
  
  // Move the label back on blur, but only if the field is empty
  input.addEventListener('blur', function(e) {
    container.classList.remove('has-focus');
    
    if(e.target.value == '') {
      container.classList.remove('is-floating');
    }
  });

  //focusable skip to main content
  window.addEventListener("hashchange", function(event) {
    var element = document.getElementById(location.hash.substring(1));
    if (element) {
        if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) {
            element.tabIndex = -1;
        }
        element.focus();
    }
  }, false);

  //Plus | Minus Buttons on Product Template and Quick Buy
  $('.plus-button').on('click', function(e) {
    e.preventDefault();
    var siblingLabel = $(this).siblings('.form__label-quantity');
    var childInput = $(siblingLabel).children('.product__quantity_field');
    var val = parseInt($(childInput).val());
    $(childInput).val(val + 1).change();
  });
  
  $('.minus-button').on('click', function(e) {
    e.preventDefault();
    var siblingLabel = $(this).siblings('.form__label-quantity');
    var childInput = $(siblingLabel).children('.product__quantity_field');
    var val = parseInt($(childInput).val());
    if (val === 0 || val === 1) {
    } else {
      $(childInput).val(val - 1).change();
    }
  });

  $('.login-form__forgot').on('click', function(e) {
    e.preventDefault();
    $('.recover-form').toggleClass('hide');
  });

  $("#newsletter-signup").submit(function(e) { 
    $(".newsletter-success").removeClass( "hide-alert" );
  });

  // Global Alert Banner
  if(Cookies.get('banner-close')) {
    $('.banner-alerts').addClass('hide');
  } else {
    $('.banner-alerts').removeClass('hide');
  };

  $('.close-alert-banner-button').on('click', function(e) {
    e.preventDefault();
    $('.banner-alerts').addClass('hide');
    Cookies.set('banner-close', true, { expires: 7 });
  });
  
});
